import ScrollReveal from 'scrollreveal'

const revealClass = '.reveal'

const options = {
  duration: 1000,
  easing: 'ease-in-out',
  scale: 1,
  distance: '25px',
}

ScrollReveal().reveal(revealClass, options)
